export default "/yt-weeths.a0b966d409eb5af77557685a3268ac6d.svg";